<template>
    <div class="button-container">
        <a v-if="!!isHref" @click.prevent="handleClick()"
           :href="typeof isHref == 'string' ? isHref : isHref.href"
           :class="['button', button.getType(), { 'button-disabled': isDisabled, 'is-dropdown': isDropdown }]">
            <i :class="['material-icons', { 'icon-loading': isLoading }]">{{ button.getIcon(isLoading) }}</i>
            <span>{{ button.getText() }}</span>
            <i class="material-icons drop-down-arrow">arrow_drop_down</i>
        </a>
        <div v-else @click="handleClick($event)" :class="['button', button.getType(), { 'button-disabled': isDisabled, 'is-dropdown': isDropdown }]">
            <i :class="['material-icons', { 'icon-loading': isLoading }]">{{ button.getIcon(isLoading) }}</i>
            <span>{{ button.getText() }}</span>
            <i class="material-icons drop-down-arrow">arrow_drop_down</i>
        </div>

        <div v-if="showDropdown" class="dropdown">
            <CustomButton v-for="(opt, index) in dropdownOptions" :key="index"
                          :buttonText="opt.text" :buttonType="opt.type"
                          :callback="opt.callback" :isLoading="opt.loading" />
        </div>
    </div>
</template>

<script>
    import CustomButton from '@/mixins/classes/CustomButton'

    export default {
        name: "CustomButton",
        props: {
            buttonType: String,
            buttonText: String,
            callback: Function,
            isLoading: Boolean,
            isDisabled: Boolean,
            isHref: [String, Object],
            dropdownOptions: Array,
        },
        watch: {
            dropdownOptionIsLoading(newValue, oldValue) {
                const loadingStopped = newValue === false && oldValue === true;

                if (loadingStopped) {
                    this.showDropdown = false;
                }
            }
        },
        computed: {
            dropdownOptionIsLoading() {
                if (!this.isDropdown) return false;

                return this.dropdownOptions.filter(option => option.loading).length > 0;
            },
        },
        data() {
            return {
                button: new CustomButton(this.buttonType, this.buttonText),
                showDropdown: false,
                isDropdown: !!this.dropdownOptions
            }
        },
        methods: {
            handleClick(evt) {
                if (!!this.isHref) {
                    this.isHref.href ? window.open(this.isHref.href, this.isHref.target) : window.location.href = this.isHref
                }

                if (!this.isDropdown) {
                    if (typeof this.callback === 'function') this.callback(evt);

                    return;
                }

                this.showDropdown = !this.showDropdown;
            },
        }
    }
</script>

<style scoped lang="scss">
    @include material-icon-loading;

    .button {
        display: flex;
        justify-content: center;
        align-items: center;
        width: max-content;
        height: 40px;
        padding: 8px 12px;

        font-size: 14px;
        color: #fff;
        background: $green;
        box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
        border-radius: 3px;
        cursor: pointer;

        &:hover {
            opacity: .75;
        }

        &.close {
            opacity: 1;
            text-shadow: none;
            background: rgba($black-1, .5);
        }

        &.download, &.archive {
            background: $deep-blue;
        }

        &.delete {
            margin-bottom: 0;
        }

        &.delete,
        &.decline,
        &.not-found-type {
            background: $error;
        }

        &.link {
            color: $green;
            background: #fff;
            border: 1px solid $green;

            &.button-disabled {
                border: 0;
            }
        }

        &.download i,
        i.icon-loading {
            font-size: 20px;
        }

        span {
            margin-left: 4px;
            font-weight: normal;
        }

        &.button-disabled {
            cursor: default;
            pointer-events: none;
            color: rgba($black-1, .5);
            background: rgba($black-1, .25);
        }

        .drop-down-arrow {
            display: none;
        }

        i {
            font-size: 24px;
            line-height: 1;
        }
    }

    .button-container {
        display: flex;
        position: relative;

        .is-dropdown {
            position: relative;
            padding-right: 8px;

            span {
                margin-right: 4px;
            }

            & > .drop-down-arrow {
                display: block;
            }
        }

        .dropdown {
            z-index: 10;
            position: absolute;
            top: 48px;
            right: 0;
            min-width: 80%;

            background: #fff;
            box-shadow: 0 0 8px rgba(0, 0, 0, 0.15);
            border-radius: 3px;

            .button {
                width: 100%;

                box-shadow: none;
                color: $black-1;
                background: transparent;
                border-radius: 0;
                border-bottom: 1px solid rgba($black-1, .25);
            }

            .button-container:last-of-type .button {
                border-bottom: 0;
            }
        }
    }
</style>
